<template>
    <div :class="`new-typeahead dropdown ${showMenu ? 'focused' : ''}`" ref="dropdownRef">
        <!-- INPUT -->
        <input
            type="text"
            :class="`form-control form new-typeahead-input pe-4 ${inputClasses}`"
            v-model="searchKey"
            autocomplete="off"
            @keydown="handleInputKeydown($event)"
            @focus="handleInputFocus()"
            ref="searchInputRef"
            :placeholder="placeholder"
            :disabled="disabled"
            @blur="emitBlur"
        />
        <i class="fas fa-search me-2 new-typeahead-search" v-if="!hideIcon"></i>
        <!-- DROPDOWN MENU -->
        <ul
            :class="`dropdown-menu ${showMenu ? 'show' : ''}`"
            ref="dropdownMenuRef"
            v-if="searchKey?.length > 0 || (data && data.length > 0)"
        >
            <!-- SEARCH RESULTS -->
            <li
                v-for="option in searchResults"
                :class="`dropdown-item ${highlightedOption && highlightedOption === option ? 'active' : ''}`"
                @click="handleMenuSelection(option)"
                :ref="`optionRefs-$index`"
                v-show="searchResults.length > 0"
            >
                <span class="me-2" v-html="option.name"></span>
            </li>
            <li class="dropdown-divider" v-if="noMatchesFound && isCustomAddEnabled && !isLoading"></li>
            <!-- ADDING SEARCH KEY -->
            <li
                v-if="noMatchesFound && isCustomAddEnabled && !isLoading"
                @click="addCustomOption()"
                :class="`dropdown-item ${isNewHighlightedOption ? 'active' : ''}`"
                ref="customAddElementRef"
            >
                <span>
                    <strong class="me-2">{{ searchKey }}</strong>
                    <strong :class="`${isNewHighlightedOption ? '' : 'text-app-secondary'}`" v-if="!customAddMessage">
                        (Add<span v-if="entity"> as {{ entity }}</span
                        >)
                    </strong>
                    <strong v-else> ({{ customAddMessage }}) </strong>
                </span>
            </li>
            <!-- CHAR LIMIT MESSAGE -->
            <li class="dropdown-header text-default" v-if="searchKey && searchKey.length < searchCharLimit">
                {{ characterLimitMessage }}
            </li>
            <template v-if="searchKey?.length >= searchCharLimit">
                <!-- NO RESULT -->
                <li
                    class="dropdown-header text-default"
                    v-if="!isCustomAddEnabled && !isLoading && !isError && searchResults.length <= 0 && isAuthorized"
                >
                    {{ noResultsMessage }}
                </li>
                <!-- ERROR -->
                <li
                    class="dropdown-header text-default"
                    v-if="isError && !isLoading && searchResults.length <= 0 && isAuthorized"
                >
                    {{ errorMessage }}
                </li>
                <!-- Insufficient User Permissions -->
                <li
                    class="dropdown-header text-default"
                    v-if="isError && !isLoading && searchResults.length <= 0 && !isAuthorized"
                >
                    {{ notAuthorizedText }}
                </li>
                <!-- LOADING -->
                <li class="dropdown-header text-default" v-if="isLoading">
                    {{ loadingMessage }}
                </li>
            </template>
        </ul>
    </div>
</template>

<style lang="scss" src="./NewTypeahead.scss"></style>

<script lang="ts" src="./NewTypeahead"></script>
